var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class LetrwingTableState {
    constructor(headers, getId, arraySorter) {
        this.getId = getId;
        this.arraySorter = arraySorter;
        this.rows = new Map();
        this.selectedRow = new Set();
        makeObservable(this);
        this.header = headers;
    }
    addToSelcted(row) {
        this.selectedRow.add(row);
    }
    removeFromSelected(row) {
        this.selectedRow.delete(row);
    }
    toggleSelection(row) {
        var _a;
        let sel = false;
        if (this.rowSelected(row)) {
            this.removeFromSelected(row);
        }
        else {
            sel = true;
            this.addToSelcted(row);
        }
        (_a = this.onRowSelecChanged) === null || _a === void 0 ? void 0 : _a.call(this, sel, row);
    }
    rowSelected(row) {
        return this.selectedRow.has(row);
    }
    addHeaders(header) {
        header.forEach(h => this.header.push(h));
    }
    addRows(column) {
        column.forEach(cl => this.addRow(cl));
    }
    addRow(column) {
        this.rows.set(this.getId(column), column);
    }
    removeRow(column) {
        this.rows.delete(this.getId(column));
    }
    getRows() {
        const values = Array.from(this.rows.values());
        return this.arraySorter ? values.sort(this.arraySorter) : values;
    }
    removeAllRows() {
        this.rows.clear();
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrwingTableState.prototype, "header", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrwingTableState.prototype, "rows", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrwingTableState.prototype, "selectedRow", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrwingTableState.prototype, "addToSelcted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrwingTableState.prototype, "removeFromSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrwingTableState.prototype, "addHeaders", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrwingTableState.prototype, "addRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrwingTableState.prototype, "addRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrwingTableState.prototype, "removeRow", null);
